<div class="modal-container">
  <ion-button class="button back primary stop-screenshare-button" (click)="stopSharingScreen()">
    {{ buttonLabel | translate }}
  </ion-button>
</div>
